import { SlidersHorizontal } from 'lucide-react'

import {
  formatScoringSummary,
  scoringPresetLabel,
  type ScoringConfig,
} from '@/components/admin/evaluation-rubrics/rubric-read-helpers'
import { rubricSectionHighlight } from '@/components/admin/evaluation-rubrics/rubric-section-ids'
import { EntityManageSection } from '@/components/ui/entity-manage-section'
import { type ScoringPresetKey } from '@/lib/rubric-publish-payload'

type RubricScoringSectionProps = {
  scoring: ScoringConfig
  scoringPreset: ScoringPresetKey | 'custom'
  highlighted?: boolean
  onEdit: () => void
  defaultOpen?: boolean
}

export function RubricScoringSection({
  scoring,
  scoringPreset,
  highlighted,
  onEdit,
  defaultOpen = true,
}: RubricScoringSectionProps) {
  return (
    <div id={rubricSectionHighlight('scoring')}>
      <EntityManageSection
        title="Scoring blend"
        subtitle="How structured overlap, semantic similarity, and deep AI judging combine"
        leadingIcon={SlidersHorizontal}
        onEdit={onEdit}
        editAriaLabel="Edit scoring blend"
        editTitle="Edit scoring"
        highlighted={highlighted}
        agentHighlight={rubricSectionHighlight('scoring')}
        collapsible
        defaultOpen={defaultOpen}
      >
        <div className="space-y-1 text-sm">
          <p className="font-medium">{scoringPresetLabel(scoringPreset, scoring)}</p>
          <p className="text-muted-foreground">{formatScoringSummary(scoring)}</p>
        </div>
      </EntityManageSection>
    </div>
  )
}
